import { useBingoGameStore } from "@/plugins/bingo/state/bingoGameStore";

/**
 * CalledHistory: vertical scrollable list of every number called this game
 * with timestamps. Newest at the top. Host-only, not shown on Projector.
 */
export default function CalledHistory() {
  const called = useBingoGameStore((s) => s.called);
  const reversed = [...called].reverse();

  return (
    <div className="flex flex-col min-h-0 flex-1">
      <div className="text-[10px] tracking-[0.3em] uppercase text-[color:var(--ic-text-muted)] mb-2">
        History
        <span className="ml-2 text-[color:var(--ic-text-muted)]">
          ({called.length})
        </span>
      </div>
      <div
        data-testid="host-history"
        className="flex-1 min-h-0 overflow-y-auto rounded-md border border-[color:var(--ic-border-subtle)] bg-[color:var(--ic-bg-elevated)] divide-y divide-[color:var(--ic-border-subtle)]"
      >
        {reversed.length === 0 && (
          <div className="p-4 text-xs text-[color:var(--ic-text-muted)] text-center tracking-widest uppercase">
            No numbers called yet
          </div>
        )}
        {reversed.map((c, idx) => {
          const t = new Date(c.calledAt);
          const ts = isNaN(t.getTime())
            ? ""
            : t.toLocaleTimeString([], { hour12: false });
          const order = called.length - idx;
          return (
            <div
              key={`${c.value}-${c.calledAt}-${idx}`}
              data-testid={`host-history-item-${c.value}`}
              className="px-3 py-2 flex items-center justify-between text-sm"
            >
              <div className="flex items-center gap-3">
                <span
                  className="w-6 text-right text-[10px] tabular-nums text-[color:var(--ic-text-muted)]"
                >
                  #{order}
                </span>
                <span
                  className="ic-font-display font-semibold text-lg"
                  style={{ color: "var(--ic-primary)" }}
                >
                  {c.value}
                </span>
              </div>
              <span className="text-[10px] tabular-nums text-[color:var(--ic-text-muted)]">
                {ts}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
